export function sinFromDegrees(angle: number) {
  return Math.sin(angle * (Math.PI / 180));
}

export function cosFromDegrees(angle: number) {
  return Math.cos(angle * (Math.PI / 180));
}

export function precisionRound(number: number, precision: number) {
  const factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
}

export function radiansToDegrees(radians: number) {
  return radians * (180 / Math.PI);
}

export function getMean(values: number[]) {
  if (values.length === 0) return 0;

  return values.reduce((a, c) => a + c, 0) / values.length;
}

export function standardDeviation(values: number[]) {
  if (values.length === 0) return 0;

  const mean = getMean(values);
  const meanDiffSquaredValues = values.map((v) => Math.pow(v - mean, 2));
  const meanDiffSquaredMean = getMean(meanDiffSquaredValues);

  return Math.sqrt(meanDiffSquaredMean);
}

export function clamp(value: number, min: number, max: number) {
  return Math.max(Math.min(value, max), min);
}
